/*
	Add to cart for the Ofen 3 sections, and the launch discount they print
	beside the button.

	WHY THE TWO JOBS SHARE A FILE. Both sections that need them render on the
	same page, so one copy of the fetch and one reading of the launch panel is
	the whole of it. Loaded with defer from each section; the guard below makes
	the second tag a no-op.

	WHY THE BUTTONS ADD TO CART RATHER THAN LINK. They used to be links to
	`?variant=`, on the product page they already sit on. Three quarters of the
	time that reloaded the same page with a different variant selected, and the
	remaining quarter reloaded the same page with nothing changed at all. Either
	way the reader lost their scroll position and got no closer to buying.

	WHERE THE DISCOUNT COMES FROM. The campaign is configured once, on
	x-21e-ofen3-launch-countdown, which already renders a panel carrying the
	percentage, the code, and a map of every formatted price to its discounted
	twin. A section cannot read another section's settings, so these sections
	read that panel's markup instead. It means there is still exactly one place
	to end the campaign (switch the product off the launch template), an expired
	deadline silently takes the discount off these buttons too, and a template
	without the launch section shows no discount rather than a stale one.
*/
(function () {
	if (window.Ofen3Buy) return;

	var launch;

	function readLaunch() {
		var panel = document.querySelector('[data-o3-launch]');
		if (!panel) return null;

		var percent = parseInt(panel.getAttribute('data-percent'), 10) || 0;
		if (percent <= 0 || percent >= 100) return null;

		var map = {};
		var mapEl = panel.querySelector('[data-o3-price-map]');
		if (mapEl) {
			try {
				map = JSON.parse(mapEl.textContent);
			} catch (e) {
				map = {};
			}
		}

		return {
			percent: percent,
			code: panel.getAttribute('data-code') || '',
			/*
				Formatted price in, formatted launch price out. Both strings were
				produced by the same `money` filter in the same request, so a
				VAT-excluded display or a Markets conversion is already in them and
				there is no second rounding here to disagree with the product page.
			*/
			priceOf: function (text) {
				return map[(text || '').trim()] || null;
			}
		};
	}

	/*
		Put the launch code into the session before anything is added, so the cart
		the drawer draws is already the discounted one. The launch section does the
		same on page load and this shares its sessionStorage key, so a normal visit
		still costs exactly one call; this is the belt to that braces, for the case
		where the page load call has not landed yet or was never made.

		Memoised for the life of the page: whatever happened here, it happened once.
	*/
	var discountApplied;

	function applyDiscount() {
		var L = readLaunchOnce();
		if (!L || !L.code) return Promise.resolve();
		if (discountApplied) return discountApplied;

		var key = '21e_discount_' + L.code;
		var already = false;
		try {
			already = sessionStorage.getItem(key) === '1';
		} catch (e) {
			/* Private mode or blocked storage: fall through and apply anyway. */
		}

		if (already) {
			discountApplied = Promise.resolve();
			return discountApplied;
		}

		/* The localized root, so the call stays on the storefront the reader is on.
		   /discount/<code> is Shopify's own route: it sets the code for the session
		   and carries through to checkout. */
		var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

		discountApplied = fetch(root + 'discount/' + encodeURIComponent(L.code), {
			credentials: 'same-origin'
		})
			.then(function () {
				try {
					sessionStorage.setItem(key, '1');
				} catch (e) {}
			})
			.catch(function () {});

		return discountApplied;
	}

	function cartElement() {
		/* Same order product-form.js uses, so these buttons land in whichever of
		   the two the shop is configured for. */
		return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	}

	/*
		Cached after the first call. Callers must be inside DOMContentLoaded: this
		file is deferred, so it executes with the document parsed, but an inline
		section script runs while the panel may still be unparsed.
	*/
	function readLaunchOnce() {
		if (launch === undefined) launch = readLaunch();
		return launch;
	}

	window.Ofen3Buy = {
		launch: readLaunchOnce,

		/*
			The campaign line, ready to print, or an empty string.

			sections.misc.discount-applied is maintained for the six markets the
			Ofen 3 sells in, the same six that carry the rest of the Ofen 3 copy.
			Anywhere else `t` renders a "Translation missing" sentence rather than
			nothing, and that must not reach a card.
		*/
		note: function (template, percent) {
			if (!template || template.indexOf('Translation missing') === 0) return '';
			return template.replace('[percent]', percent);
		},

		/*
			One line, quantity one, then the drawer is re-rendered from the sections
			the response carries and opens itself. Same contract as product-form.js.

			The published event deliberately does NOT claim source 'product-form'.
			snippets/ofen3-accessories listens for that source and drags any ticked
			accessory along with the heater, which is right for the buy box and wrong
			for a card further down the page that the accessory checkboxes do not
			belong to.
		*/
		add: function (variantId, button) {
			var id = Number(variantId);
			if (!id) return Promise.resolve(false);
			if (button && button.getAttribute('aria-busy') === 'true') return Promise.resolve(false);

			var cart = cartElement();
			var body = { items: [{ id: id, quantity: 1 }] };

			if (cart && typeof cart.getSectionsToRender === 'function') {
				body.sections = cart.getSectionsToRender().map(function (s) {
					return s.id;
				});
				body.sections_url = window.location.pathname;
				/* Where focus returns to when the drawer closes. */
				if (typeof cart.setActiveElement === 'function') {
					cart.setActiveElement(button || document.activeElement);
				}
			}

			if (button) button.setAttribute('aria-busy', 'true');

			/*
				The code first, then the line. The add response carries the rendered
				drawer back with it, so applying the discount after the add would hand
				the reader a drawer showing the price they were just promised was
				discounted. On every visit after the first this resolves without a
				request.
			*/
			return applyDiscount()
				.then(function () {
					return fetch(window.routes.cart_add_url, {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
						body: JSON.stringify(body)
					});
				})
				.then(function (r) {
					return r.json();
				})
				.then(function (res) {
					/* A rejected line comes back 200 with a status field on it, not as a
					   failed request, so this is the only place an out of stock variant
					   is caught. */
					if (res && res.status) {
						if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'ofen3-section',
								productVariantId: String(id),
								errors: res.description,
								message: res.message
							});
						}
						return false;
					}

					/* No drawer and no notification configured: the cart page is the only
					   place left that can show what just happened. */
					if (!cart) {
						window.location = window.routes.cart_url;
						return true;
					}

					if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'ofen3-section',
							productVariantId: String(id)
						});
					}

					if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
					if (res && res.sections) cart.renderContents(res);
					return true;
				})
				.catch(function (e) {
					console.error(e);
					return false;
				})
				.finally(function () {
					if (button) button.removeAttribute('aria-busy');
				});
		}
	};
})();
